import ClinicSurvey from "./Page/ClinicSurvey";


function App() {
  return (
    <div className="comp-block">
      <ClinicSurvey />
    </div>
  );
}

export default App;
